import { combineReducers } from 'redux';
import settings from './settings.reducer';
import selected from './selected.reducer';
import data from './data.reducer';
import deploymentFrequency from './deployment-frequency';
import timePeriods from './time-periods';
import environmentTypes from './environment-types';
import summary from './summary';
import leadTime from './lead-time';
import changeVolume from './change-volume';
import activity from './activity';

const reducers = combineReducers({
    settings,
    data,
    selected,
    deploymentFrequency,
    environmentTypes,
    timePeriods,
    summary,
    leadTime,
    changeVolume,
    activity
});

export default reducers;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/reducers.js